// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2j_CF","inputWrap":"styles_inputWrap__2YuHL","input":"styles_input__9pbTW"};